import { Filter } from "./PbiReport.types";

export const generateFilters = (language: string): Filter[] => {
  const tables = [
    "Summary_table",
    "Esg",
    "Modelling",
    "Graph_translations",
    "Summary_table_waste_water",
    "Summary_table_subsidiaries",
    "Seda Voda",
    "Destratifikatory",
    "Elektrické Auta",
    "Chytré Meraky",
    "Zelená Elektrina",
    "Tepelné Cerpadlo",
    "trans_double_materiality",
    "trans_double_materiality_2",
    "trans_emission_source",
    "trans_waste_water",
    "trans_summary",
    "trans_modelling",
    "trans_titles",
    "trans_esg",
    "pbi_view_dma_ranges",
    "trans_ratio_indicator",
    "trans_consolidation_question",
    "trans_master",
  ];

  return tables.map((table) => {
    return {
      $schema: "https://powerbi.com/product/schema#basic",
      target: {
        table: table,
        column: "Attribute",
      },
      operator: "In",
      values: [language.replace("cs", "cz").toUpperCase()],
      filterType: 1,
    };
  });
};

export const getWindowSize = (): {
  innerWidth: number;
  innerHeight: number;
} => {
  const { innerWidth, innerHeight } = window;

  return { innerWidth, innerHeight };
};
